<template>
  <div class="main">
    <my_menu2 page_name="员工查询" back_type="close" back_icon="md-close"></my_menu2>

    <div class="content">
      <div>
        <Alert type="success">可查询员工过往面试、入职记录、归属人、工资记录等</Alert>
        <div class="search_div2">

          <Select v-model="search_type" style="width:120px">
            <Option value="idcard">身份证号</Option>
            <Option value="phone">手机号码</Option>
            <Option value="name">姓名</Option>
            <Option value="resume_id">简历ID</Option>
          </Select>
          <div class="search_div">
            <Input prefix="md-alert" style="width: 300px" search v-model="search_value" enter-button placeholder="输入后搜索"
              @on-search="search_btn" @on-enter="search_btn" />
          </div>
        </div>
      </div>
      <div class="item_div2">
        <div class="search_result" v-if="search_resume_list.length > 0">
          搜索到{{ search_resume_list.length }}条记录
        </div>
        <div v-for="(item, i) in search_resume_list" :key="i" class="item_div" @click="click_search(item)">
          <div class="item_div45">
            <div>姓名：{{ item.name }}</div>
            <div>手机号：{{ item.phone }}</div>
            <div>简历ID：{{ item.resume_id }}</div>
            <div>身份证号：{{ item.idcard }}</div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import my_menu2 from "@/component/menu/menu2.vue";
import { http, open_new_page } from "@/utils/http.js";

export default {
  components: {
    my_menu2,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      search_value: "",
      search_type: 'idcard',
      loading: false,
      search_resume_list: []
    };
  },

  mounted() {
    this.window_change();
    // this.get_user_list()
  },

  methods: {

    search_btn() {

      if (this.search_value == '') {
        this.$Message.error("请输入信息后搜索");
        return
      }

      this.loading = true;

      var that = this;
      var obj = {
        search_type: this.search_type,
        search_value: this.search_value
      };

      that.search_resume_list = []
      http("post", process.env.VUE_APP_HOST + "/query_staff/search_staff", obj, true)
        .then((res) => {
          if (res.code == 0) {
            console.log(res)
            that.search_resume_list = res.data.search_resume_list;

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    click_search(item) {

      open_new_page("/query_staff?idcard=" + item.idcard);
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.search_result {
  background-color: rgb(157, 215, 175);
  width: 120px;
  height: 30px;
  border-radius: 5px;
  box-shadow: 0 0 3px #ecebeb;
  ;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  right: 10px;
  top: 100px;
}

.item_div45 {

  width: 300px;
  background-color: white;

  padding: 10px;
  border-radius: 3px;
}

.item_div {
  display: flex;
  justify-content: center;
  text-align: left;
  font-size: 13px;
  margin-bottom: 10px;
}

.item_div45:hover {
  background-color: #e9e9e9;
  cursor: pointer;
}

.item_div2 {
  height: calc(100vh - 150px);
  overflow: auto;
  margin-top: 5px;
  position: relative;
}

.search_div2 {
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.search_div {
  padding: 20px 0;
  display: flex;
  justify-content: center;
}

.tishi {
  font-size: 13px;
  color: #888;
  text-align: left;
  margin-bottom: 10px;
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content {
  padding: 50px 10px 10px 10px;
  text-align: center;
  height: calc(100vh - 60px);
}

.main {
  background: #f5f7f9;
  min-height: 100vh;
}
</style>
